import React, { useEffect, useState } from 'react'
import PropagateLoader from "react-spinners/PropagateLoader";
import DataTables from '../LMS_DATA_TABLE/DataTable';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { templateListRes, templateListTodo } from '../../LMS_Redux/LMS_Slices/Certificate/TemplateList';
import { FaEdit } from 'react-icons/fa';
import { IoInformationCircleOutline } from 'react-icons/io5';
import { FaTrash } from 'react-icons/fa6';
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
import { deleteTemplateRes, deleteTemplateTodo } from '../../LMS_Redux/LMS_Slices/Certificate/DeleteTemplate';
import { templatePreviewRes, templatePreviewTodo } from '../../LMS_Redux/LMS_Slices/Certificate/TemplatePreview';

export default function TemplateList() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.templateList && state.templateList.data && state.templateList.data.data)
    const [loading, setLoading] = useState(true)
    // console.log(data)

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'SERIAL',
            valueGetter: 'node.rowIndex + 1',
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 100
        },
        {
            headerName: 'HOD',
            field: 'hod_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
            width: 300
        },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params => <span className={params.value == 'active' ? 'badge text-bg-success' : 'badge text-bg-danger'} style={{ textTransform: 'capitalize' }}>{params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <IoInformationCircleOutline size={20} className='eye'
                        onClick={() => view_template(params)}
                        data-tooltip-id='details'
                        data-tooltip-content="View Template!"
                        data-tooltip-place="bottom"
                    />

                    <FaEdit size={20} className='edit ms-3'
                        onClick={() => edit_template(params)}
                        data-tooltip-id='edit'
                        data-tooltip-content="Edit Template!"
                        data-tooltip-place="bottom"
                    />

                    <FaTrash size={18} className='delete ms-3'
                        onClick={() => delete_template(params)}
                        data-tooltip-id='delete'
                        data-tooltip-content="Delete Template!"
                        data-tooltip-place="bottom"
                    />

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='edit' style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='delete' style={{ backgroundColor: "rgb(239, 61, 80)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            // wrapText: true,
            autoHeight: true,
        }
    ])

    const edit_template = (params) => {
        navigate('/update_certificate_template', { state: params.data })
    }

    const delete_template = (params) => {
        Swal.fire({
            title: 'Delete Template',
            text: `Are you sure want to Delete Template?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#105684',
            cancelButtonColor: '#9d9d9d',
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result.isConfirmed) {
                // console.log(params.data)
                dispatch(deleteTemplateTodo(params.data.id)).then(() => del_template_res())
            }
        })
    }

    const del_template_res = () => {
        if (deleteTemplateRes && deleteTemplateRes.success) {
            Swal.fire(
                'Template Status',
                deleteTemplateRes.message,
                'success'
            )
            setLoading(true)
            dispatch(templateListTodo()).then(() => template_res())
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: deleteTemplateRes.message,
            })
        }
    }

    const view_template = (params) => {
        setLoading(true)
        dispatch(templatePreviewTodo(params.data.id)).then(() => template_preview_res())
    }

    const template_preview_res = () => {
        if (templatePreviewRes && templatePreviewRes.success) {
            setLoading(false)
            window.open(templatePreviewRes && templatePreviewRes.data && process.env.REACT_APP_IMAGE_URL + templatePreviewRes.data.certificate, "_blank")
        } else {
            setLoading(false)
        }
    }

    const template_res = () => {
        if (templateListRes && templateListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(templateListTodo()).then(() => template_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Certificate / </span>
                    <span className='icon2'>Template List</span>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <DataTables
                        rowData={data}
                        columnDefs={columnDefs}
                    />
                }
            </div>
        </>
    )
}
